import React from 'react';

interface IProps {
  percentageClassName?: string;
  squareSize: number; // Size of the enclosing square
  percentage: number;
  strokeWidth: number;
  currencySign?: string;
  currencyAmount?: number;
  innerLabelClassName?: string;
  innerLabel?: string;
  circleColor?: string;
  progressColor?: string;
}

const Donut = ({
  squareSize,
  strokeWidth,
  percentage,
  percentageClassName,
  currencySign,
  currencyAmount,
  innerLabelClassName,
  innerLabel,
  progressColor,
  circleColor,
}: IProps) => {
  // SVG centers the stroke width on the radius, subtract out so circle fits in square
  const radius = (squareSize - strokeWidth) / 2;
  // Enclose circle in a circumscribing square
  const viewBox = `0 0 ${squareSize} ${squareSize}`;
  // Arc length at 100% coverage is the circle circumference
  const dashArray = radius * Math.PI * 2;
  // Scale 100% coverage overlay with the actual percent
  const dashOffset = dashArray - (dashArray * percentage) / 100;

  const textToShowInDonut =
    currencyAmount !== null && currencyAmount !== undefined && currencySign
      ? `${currencySign}${parseFloat(currencyAmount.toFixed(2))}`
      : `${parseFloat(percentage.toFixed(1))}%`;

  return (
    <div className='relative w-fit'>
      <div className='flex flex-col items-center absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]'>
        <span id='percentage' className={percentageClassName}>
          {textToShowInDonut}
        </span>
        <span className={innerLabelClassName}>{innerLabel}</span>
      </div>
      <svg width={squareSize} height={squareSize} viewBox={viewBox} fill='transparent'>
        <circle
          className={`bg-bw00 ${circleColor || 'stroke-action01'}`} // circle-background
          cx={squareSize / 2}
          cy={squareSize / 2}
          r={radius}
          strokeWidth={`${strokeWidth}px`}
        />
        <circle
          className={progressColor || 'stroke-action03'} // circle-progress
          cx={squareSize / 2}
          cy={squareSize / 2}
          r={radius}
          strokeWidth={`${strokeWidth}px`}
          // Start progress marker at 12 O'Clock
          transform={`rotate(-90 ${squareSize / 2} ${squareSize / 2})`}
          style={{
            strokeDasharray: dashArray,
            strokeDashoffset: dashOffset,
          }}
        />
      </svg>
    </div>
  );
};

export default Donut;
